import React from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import { breakpoints } from '../utils/breakpoints';

const mapStateToProps = ({ viewport: { width } }) => ({ width });

const Match = ({
  width, max, min, children
}) => {
  const props = {
    values: { width },
    minWidth: breakpoints[min] || null,
    maxWidth: max ? breakpoints[max] - 1 : null
  };

  return <MediaQuery {...props}>{ children }</MediaQuery>;
};

export default connect(mapStateToProps)(Match);



// WEBPACK FOOTER //
// ./src/universal/ui/components/Media.js